//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { db } from "../../main.js";
export default {
  data() {
    return {
      isEditing: false,
      showDeleteModal: false,
    };
  },
  methods: {
    cleanYTID(YTID) {
      if (YTID && YTID.length > 11) {
        return YTID.substring(YTID.length - 11);
      } else {
        return YTID;
      }
    },
    timeToSeconds(time) {
      var raw = String(time);
      if (raw.includes(":")) {
        var colon = raw.indexOf(":");
        return (
          parseInt(raw.substring(0, colon)) * 60 +
          parseInt(raw.substring(colon + 1))
        );
      }
      return raw;
    },
    deleteLesson(classKey, lessonKey) {
      db.ref(`lessons/${classKey}/${lessonKey}`).remove();
      this.showDeleteModal = false;
    },
    updateLesson(classKey, lessonKey, data) {
      data.duration = this.timeToSeconds(data.duration);
      data.backCamStart = this.timeToSeconds(data.backCamStart);
      data.backCamEnd = this.timeToSeconds(data.backCamEnd);
      data.backCamSrcOffset = this.timeToSeconds(data.backCamSrcOffset);
      data.YTID = this.cleanYTID(data.YTID);
      data.backCamSrc = this.cleanYTID(data.backCamSrc);
      db.ref(`lessons/${classKey}/${lessonKey}`).set(data);
      this.isEditing = false;
    },
  },
  props: {
    classKey: {
      default: null,
    },
    lessonKey: {
      default: null,
    },
    lesson: {
      default: null,
    },
    title: {
      default: null,
    },
  },
};
